import { isEmpty, isNil } from 'lodash'

import { formatTime, sharedScorecardParams } from '@/utils/helpers'

// Viewer's IANA zone; the scorecard service cuts per-day trend buckets
// at this zone's midnight. UTC fallback for runtimes that can't resolve one.
export const browserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
  } catch {
    return 'UTC'
  }
}

export const formatQACopilotFilters = (filterValues = {}, organizationId) => {
  const filterTypes = [
    { data: 'agents', key: 'agent_ids' },
    { data: 'tags', key: 'tag_ids' },
    { data: 'scorecards', key: 'scorecard_config_sids' },
    { data: 'playbooks', key: 'config_cids' },
    { data: 'voipCampaigns', key: 'voip_campaign_names' },
  ]
  const params = new URLSearchParams()
  const orgId = filterValues.organizationId || organizationId

  sharedScorecardParams(filterTypes, { ...filterValues }, params, orgId, true)

  if (!isEmpty(filterValues.dispositions?.selected)) {
    filterValues.dispositions.selected.forEach((item) => {
      params.append('dispositions', item.value)
    })
    params.set('dispositions_includes', filterValues.dispositions.includes ?? true)
  }

  if (!isNil(filterValues.threshold)) {
    params.set('threshold', filterValues.threshold)
  }

  params.set('timezone', browserTimezone())

  return params.toString()
}

export const getScorecardConfigVersionOptions = (versions) => {
  return versions.map((version) => ({
    value: version.id,
    label: `${version.name} \u2013 ${formatTime(version.modified_on)}${
      version.modified_user
        ? ` \u2013 ${version.modified_user.first_name} ${version.modified_user.last_name}`
        : ''
    }`,
  }))
}

export const filterOutUnmappedCampaigns = (campaigns) =>
  campaigns.filter((option) => option.value !== 'Unmapped' && option.label !== 'Unmapped')
